import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ar, en } from "../../assets/langs/translation";

const JobCard = ({ job }) => {
  const [showCommunication, setShowCommunication] = useState(false);
  // to set lang
  const { lang } = useSelector((state) => state.settings);
  const currentLang = lang === "en" ? en : ar;

  console.log(job);

  return (
    <div className="w-[311px] h-[270px] overflow-hidden flex flex-col items-start justify-center py-[15px] relative rounded-[12px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] border border-[#f1f1f2]">
      <div className=" w-full left-0 top-0 absolute z-0">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 250 189"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M210.521 127.563L196.086 131.924V131.923L70.5761 86.1165V114.473L196.086 162.461V162.462L249.4 142.83L249.39 142.827V99.9341L249.398 99.9312L249.401 99.9318L249.398 99.931L109.452 46.854L109.453 46.8536V34.493L109.449 34.4913L123.883 28.6766V0.319931L71.6796 19.9514L71.6891 19.9551V62.1225L71.6881 62.1227L71.6853 62.1221L71.6875 62.123L211.63 114.471L211.626 114.473L210.516 127.561L210.521 127.563ZM249.398 76.6651L123.889 28.6769V0.320297L249.398 46.1272V76.6651ZM124.994 188.637L86.519 173.369H163.467L163.465 173.368H163.47L124.994 188.637ZM163.465 173.368L124.991 158.1L86.5148 173.369H86.519L86.5176 173.368H163.465ZM0.595341 140.65L53.9068 162.461L92.3828 147.193L0.597202 140.649L0.59763 140.649L92.3842 147.192L38.3594 126.834V33.0399L0.595341 48.3088V140.648L0.593754 140.649L0.595341 140.649V140.649L0.593311 140.649L0.595341 140.65ZM0.595341 140.65V140.649L0.597202 140.649L0.595341 140.65ZM0.595341 140.649L0.59763 140.649L38.3594 126.835V126.834L38.3578 126.834L0.595341 140.648V140.649Z"
            fill="rgba(0, 47, 68, .019)"
          />
        </svg>
      </div>

      <div className="border-b z-10 border-[#f1f1f2] w-full flex flex-col items-start justify-start px-[15px] pb-[9px] ">
        <div className="text-start text-black text-xs font-bold font-['Cairo']">
          {job?.title}
        </div>
        <div className="text-start text-[#888888] text-[10px] font-normal font-['Cairo']">
          {job?.description}
        </div>
      </div>

      <div className="flex-col z-10 justify-start items-start px-[15px] py-[10px] gap-[10px] inline-flex">
        <div className="justify-start items-center gap-[5px] inline-flex">
          <svg
            width="16"
            height="15"
            viewBox="0 0 16 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.625 8.75C13.625 8.06063 13.0644 7.5 12.375 7.5H11.125C10.4356 7.5 9.875 8.06063 9.875 8.75C8.84125 8.75 8 9.59125 8 10.625V13.125C8 14.1587 8.84125 15 9.875 15H13.625C14.6587 15 15.5 14.1587 15.5 13.125V10.625C15.5 9.59125 14.6587 8.75 13.625 8.75ZM11.125 8.125H12.375C12.72 8.125 13 8.405 13 8.75H10.5C10.5 8.405 10.78 8.125 11.125 8.125ZM9.875 9.375H13.625C14.3144 9.375 14.875 9.93563 14.875 10.625V11.25H8.625V10.625C8.625 9.93563 9.18563 9.375 9.875 9.375ZM13.625 14.375H9.875C9.18563 14.375 8.625 13.8144 8.625 13.125V11.875H11.4375V12.8125C11.4375 12.985 11.5775 13.125 11.75 13.125C11.9225 13.125 12.0625 12.985 12.0625 12.8125V11.875H14.875V13.125C14.875 13.8144 14.3144 14.375 13.625 14.375ZM6.75 14.6875C6.75 14.86 6.61 15 6.4375 15H3.3125C1.76188 15 0.5 13.7381 0.5 12.1875V2.8125C0.5 1.26188 1.76188 0 3.3125 0H7.6875C9.23812 0 10.5 1.26188 10.5 2.8125V5.9375C10.5 6.11 10.36 6.25 10.1875 6.25C10.015 6.25 9.875 6.11 9.875 5.9375V2.8125C9.875 1.60625 8.89375 0.625 7.6875 0.625H3.3125C2.10625 0.625 1.125 1.60625 1.125 2.8125V12.1875C1.125 13.3938 2.10625 14.375 3.3125 14.375H6.4375C6.61 14.375 6.75 14.515 6.75 14.6875ZM4.875 8.4375C4.875 8.61 4.735 8.75 4.5625 8.75H3.3125C3.14 8.75 3 8.61 3 8.4375C3 8.265 3.14 8.125 3.3125 8.125H4.5625C4.735 8.125 4.875 8.265 4.875 8.4375ZM8 8.4375C8 8.61 7.86 8.75 7.6875 8.75H6.4375C6.265 8.75 6.125 8.61 6.125 8.4375C6.125 8.265 6.265 8.125 6.4375 8.125H7.6875C7.86 8.125 8 8.265 8 8.4375ZM4.875 10.9375C4.875 11.11 4.735 11.25 4.5625 11.25H3.3125C3.14 11.25 3 11.11 3 10.9375C3 10.765 3.14 10.625 3.3125 10.625H4.5625C4.735 10.625 4.875 10.765 4.875 10.9375ZM4.875 3.4375C4.875 3.61 4.735 3.75 4.5625 3.75H3.3125C3.14 3.75 3 3.61 3 3.4375C3 3.265 3.14 3.125 3.3125 3.125H4.5625C4.735 3.125 4.875 3.265 4.875 3.4375ZM8 3.4375C8 3.61 7.86 3.75 7.6875 3.75H6.4375C6.265 3.75 6.125 3.61 6.125 3.4375C6.125 3.265 6.265 3.125 6.4375 3.125H7.6875C7.86 3.125 8 3.265 8 3.4375ZM4.875 5.9375C4.875 6.11 4.735 6.25 4.5625 6.25H3.3125C3.14 6.25 3 6.11 3 5.9375C3 5.765 3.14 5.625 3.3125 5.625H4.5625C4.735 5.625 4.875 5.765 4.875 5.9375ZM8 5.9375C8 6.11 7.86 6.25 7.6875 6.25H6.4375C6.265 6.25 6.125 6.11 6.125 5.9375C6.125 5.765 6.265 5.625 6.4375 5.625H7.6875C7.86 5.625 8 5.765 8 5.9375Z"
              fill="#28AF60"
            />
          </svg>
          <div className="text-start text-black text-xs font-normal font-['Cairo'] leading-[15px]">
            بكالوريوس تربية رياضية
          </div>
        </div>

        <div className="justify-start items-center gap-[5px] inline-flex">
          <svg
            width="16"
            height="15"
            viewBox="0 0 16 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_2039_31198)">
              <path
                d="M4.5625 8.125H5.99563L7.22625 9.35563C7.43937 9.56875 7.72 9.67562 8 9.67562C8.28 9.67562 8.56063 9.56875 8.77375 9.35563L10.0044 8.125H11.4375C12.9881 8.125 14.25 6.86312 14.25 5.3125V2.8125C14.25 1.26188 12.9881 0 11.4375 0H4.5625C3.01188 0 1.75 1.26188 1.75 2.8125V5.3125C1.75 6.86312 3.01188 8.125 4.5625 8.125ZM2.375 2.8125C2.375 1.60625 3.35625 0.625 4.5625 0.625H11.4375C12.6438 0.625 13.625 1.60625 13.625 2.8125V5.3125C13.625 6.51875 12.6438 7.5 11.4375 7.5H9.875C9.79187 7.5 9.7125 7.53312 9.65375 7.59125L8.33187 8.91313C8.14875 9.09625 7.85063 9.09625 7.66813 8.91313L6.34625 7.59125C6.2875 7.5325 6.20813 7.5 6.125 7.5H4.5625C3.35625 7.5 2.375 6.51875 2.375 5.3125V2.8125ZM9.25 2.1875C9.25 2.015 9.39 1.875 9.5625 1.875H11.4762C11.7075 1.875 11.915 2.00312 12.0181 2.20938C12.1213 2.41563 12.0994 2.65938 11.9612 2.84438L9.90375 5.58687L11.75 5.62563C11.9225 5.62563 12.0625 5.76563 12.0625 5.93813C12.0625 6.11063 11.9225 6.25063 11.75 6.25063H9.92312C9.67562 6.25063 9.45312 6.11312 9.3425 5.89188C9.23187 5.67063 9.25562 5.41 9.40375 5.2125L11.4606 2.47L9.5625 2.50062C9.39 2.50062 9.25 2.36 9.25 2.1875ZM7.6875 4.0625C7.6875 3.89 7.8275 3.75 8 3.75H8.625C8.7975 3.75 8.9375 3.89 8.9375 4.0625C8.9375 4.235 8.7975 4.375 8.625 4.375H8C7.8275 4.375 7.6875 4.235 7.6875 4.0625ZM9.295 14.375H15.1875C15.36 14.375 15.5 14.515 15.5 14.6875C15.5 14.86 15.36 15 15.1875 15H0.8125C0.64 15 0.5 14.86 0.5 14.6875C0.5 14.515 0.64 14.375 0.8125 14.375H6.705C6.27688 13.9606 5.665 13.75 4.875 13.75H0.8125C0.64 13.75 0.5 13.61 0.5 13.4375C0.5 13.265 0.64 13.125 0.8125 13.125H4.875C6.08563 13.125 6.81875 13.5619 7.26188 14.0525C7.05938 13.4056 6.49 12.5 4.875 12.5H0.8125C0.64 12.5 0.5 12.36 0.5 12.1875C0.5 12.015 0.64 11.875 0.8125 11.875H4.875C7.34 11.875 7.85938 13.6444 7.96938 14.375H8.03062C8.14062 13.6444 8.66 11.875 11.125 11.875H15.1875C15.36 11.875 15.5 12.015 15.5 12.1875C15.5 12.36 15.36 12.5 15.1875 12.5H11.125C9.51 12.5 8.94063 13.405 8.73812 14.0525C9.18062 13.5619 9.91438 13.125 11.125 13.125H15.1875C15.36 13.125 15.5 13.265 15.5 13.4375C15.5 13.61 15.36 13.75 15.1875 13.75H11.125C10.3356 13.75 9.72375 13.9606 9.295 14.375ZM4.11438 6.24312C4.13562 6.24813 4.15688 6.25 4.17813 6.25C4.32313 6.25 4.45312 6.14875 4.48375 6.00125L4.62625 5.3125H6.4075L6.53875 5.99625C6.57125 6.16625 6.73375 6.27625 6.90438 6.24438C7.07375 6.21187 7.185 6.04813 7.1525 5.87875L6.56812 2.83125C6.47625 2.35563 6.09187 1.875 5.535 1.875C4.94937 1.875 4.58063 2.42313 4.50625 2.8075L3.87125 5.87375C3.83625 6.04312 3.94563 6.20813 4.11438 6.24312ZM5.12 2.93C5.14438 2.80313 5.29813 2.5 5.53562 2.5C5.78438 2.5 5.92812 2.80875 5.955 2.94937L6.28813 4.6875H4.75625L5.12 2.93Z"
                fill="#28AF60"
              />
            </g>
            <defs>
              <clipPath id="clip0_2039_31198">
                <rect
                  width="15"
                  height="15"
                  fill="white"
                  transform="translate(0.5)"
                />
              </clipPath>
            </defs>
          </svg>

          <div className="text-start text-black text-xs font-normal font-['Cairo'] leading-[15px]">
            {job.english === "good"
              ? currentLang.good
              : job.english === "very good"
              ? currentLang.verygood
              : currentLang.excellent}{" "}
            {currentLang.inEnglish}
          </div>
        </div>

        <div className="justify-start items-center gap-[5px] inline-flex">
          <div className="w-full text-center text-black text-[10px] font-normal font-['Cairo'] leading-[15px]">
            {currentLang.lastApplayDate}: {job.last_date}
          </div>
        </div>
      </div>

      <div className="justify-evenly z-10 items-center inline-flex w-full border-t border-b border-[#f1f1f2] ">
        <div className="justify-start items-center gap-[5px] flex py-[8px]">
          <svg
            width="11"
            height="11"
            viewBox="0 0 11 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.83333 9.66667H7.16667C8.84167 9.66667 9.14167 8.99583 9.22917 8.17917L9.54167 4.84583C9.65417 3.82917 9.3625 3 7.58333 3H3.41667C1.6375 3 1.34583 3.82917 1.45833 4.84583L1.77083 8.17917C1.85833 8.99583 2.15833 9.66667 3.83333 9.66667Z"
              stroke="#28AF60"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M3.83333 3.00004V2.66671C3.83333 1.92921 3.83333 1.33337 5.16666 1.33337H5.83333C7.16666 1.33337 7.16666 1.92921 7.16666 2.66671V3.00004"
              stroke="#28AF60"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.33334 5.91667V6.33333C6.33334 6.3375 6.33334 6.3375 6.33334 6.34167C6.33334 6.79583 6.32917 7.16667 5.50001 7.16667C4.67501 7.16667 4.66667 6.8 4.66667 6.34583V5.91667C4.66667 5.5 4.66667 5.5 5.08334 5.5H5.91667C6.33334 5.5 6.33334 5.5 6.33334 5.91667Z"
              stroke="#28AF60"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.52083 5.08337C8.55833 5.78337 7.45833 6.20004 6.33333 6.34171"
              stroke="#28AF60"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.59166 5.1958C2.52916 5.83747 3.58749 6.22497 4.66666 6.3458"
              stroke="#28AF60"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div className="text-start text-black text-[10px] font-normal font-['Cairo'] leading-[15px]">
            {job.type_of_work === "full"
              ? currentLang.fullTime
              : job.type_of_work === "part"
              ? currentLang.partTime
              : currentLang.freelance}
          </div>
        </div>
        <div className="border-r border-[#f1f1f2] h-full"></div>
        <div className="justify-start items-center gap-[5px] flex py-[8px]">
          <svg
            width="10"
            height="11"
            viewBox="0 0 10 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.35416 4.72641C1.35416 2.68515 2.98125 1.02087 5 1.02087C7.01874 1.02087 8.64583 2.68515 8.64583 4.72641C8.64583 5.71187 8.36499 6.77 7.86852 7.68415C7.37266 8.59717 6.64818 9.39055 5.74188 9.81416C5.27107 10.0342 4.72893 10.0342 4.25812 9.81416C3.35182 9.39055 2.62734 8.59717 2.13148 7.68415C1.63501 6.77 1.35416 5.71187 1.35416 4.72641ZM5 1.64587C3.33684 1.64587 1.97916 3.01982 1.97916 4.72641C1.97916 5.60019 2.23026 6.55646 2.68071 7.38587C3.13176 8.21639 3.76917 8.89572 4.52277 9.24796C4.82585 9.38962 5.17414 9.38962 5.47723 9.24796C6.23082 8.89572 6.86823 8.21639 7.31929 7.38587C7.76973 6.55646 8.02083 5.60019 8.02083 4.72641C8.02083 3.01982 6.66315 1.64587 5 1.64587ZM5 3.72921C4.48223 3.72921 4.0625 4.14894 4.0625 4.66671C4.0625 5.18447 4.48223 5.60421 5 5.60421C5.51776 5.60421 5.9375 5.18447 5.9375 4.66671C5.9375 4.14894 5.51776 3.72921 5 3.72921ZM3.4375 4.66671C3.4375 3.80376 4.13705 3.10421 5 3.10421C5.86294 3.10421 6.5625 3.80376 6.5625 4.66671C6.5625 5.52965 5.86294 6.22921 5 6.22921C4.13705 6.22921 3.4375 5.52965 3.4375 4.66671Z"
              fill="#44B975"
            />
          </svg>
          <div className="text-start text-black text-[10px] font-normal font-['Cairo'] leading-[15px]">
            {job.country}
          </div>
        </div>
        <div className="border-r border-[#f1f1f2] h-full"></div>

        <div className="justify-start items-center gap-[5px] flex py-[8px]">
          {
            <svg
              width="11"
              height="11"
              viewBox="0 0 11 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.21429 1.03571C6.21429 0.739847 6.45414 0.5 6.75 0.5H9.96429C10.0369 0.5 10.1062 0.514457 10.1694 0.540649C10.2325 0.566792 10.2917 0.605545 10.3431 0.656907C10.3944 0.708269 10.4332 0.767466 10.4594 0.830651C10.4856 0.893816 10.5 0.963077 10.5 1.03571V4.25C10.5 4.54586 10.2601 4.78571 9.96429 4.78571C9.66843 4.78571 9.42857 4.54586 9.42857 4.25V2.32904L6.94721 4.8104C7.38444 5.40301 7.64286 6.13561 7.64286 6.92857C7.64286 8.901 6.04387 10.5 4.07143 10.5C2.09899 10.5 0.5 8.901 0.5 6.92857C0.5 4.95613 2.09899 3.35714 4.07143 3.35714C4.86439 3.35714 5.59699 3.61556 6.1896 4.05279L8.67093 1.57143H6.75C6.45414 1.57143 6.21429 1.33158 6.21429 1.03571ZM5.79017 5.11309C5.34215 4.6888 4.73718 4.42857 4.07143 4.42857C2.69071 4.42857 1.57143 5.54786 1.57143 6.92857C1.57143 8.30929 2.69071 9.42857 4.07143 9.42857C5.45214 9.42857 6.57143 8.30929 6.57143 6.92857C6.57143 6.26282 6.3112 5.65785 5.88691 5.20983C5.86905 5.19601 5.85186 5.18091 5.83548 5.16452C5.81909 5.14814 5.80399 5.13095 5.79017 5.11309Z"
                fill="#28AF60"
              />
            </svg>
          }
          <div className="text-start text-black text-[10px] font-normal font-['Cairo'] leading-[15px]">
            {job.type === "male" ? currentLang.male : currentLang.female}
          </div>
        </div>
      </div>

      <div className="w-full z-10 justify-between gap-2 items-center py-[10px] px-[15px] inline-flex">
        <button
          onClick={() => setShowCommunication(true)}
          className="text-center w-[179px] justify-center items-center gap-2.5 flex rounded-lg h-[41px] bg-[#075178] text-white text-[10px] font-semibold font-['Cairo'] "
        >
          {currentLang.contactNow}
        </button>
        <div className="text-start flex flex-col items-start justify-start">
          <span className="text-black text-[10px] font-normal font-['Cairo'] ">
            {currentLang.salary} :
          </span>
          <span className="text-black text-[16px] text-nowrap font-bold font-['Cairo'] ">
            {job.salary} 
          </span>
        </div>
      </div>

      {showCommunication && (
        <div className="w-full h-full bg-[#30323699] backdrop-filter: backdrop-blur-[2px] z-40 absolute top-0 left-0 flex flex-col items-center justify-center gap-4 px-4">
          <a
            href={`https://wa.me/${job.phone}`}
            target="_blank"
            rel="noopener noreferrer"
            className="w-[194px] h-[66px] border border-[f1f1f2] bg-[#28AF60] text-white rounded-[20px] font-['Cairo'] text-sm hover:bg-[#2ed172] flex items-center justify-center gap-[5px]"
          >
            <svg
              width="26"
              height="25"
              viewBox="0 0 26 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.5784 18.0752C11.5648 18.0752 7.48575 13.9936 7.48438 8.97842C7.48575 7.70712 8.5206 6.67334 9.78878 6.67334C9.91916 6.67334 10.0482 6.68432 10.1717 6.70629C10.4434 6.75159 10.7015 6.84358 10.9389 6.98224C10.9732 7.00283 10.9966 7.03578 11.002 7.07422L11.5318 10.4145C11.5387 10.4543 11.5263 10.4927 11.5003 10.5215C11.2079 10.8455 10.8346 11.0789 10.4187 11.1956L10.2184 11.2519L10.2938 11.4455C10.9773 13.1863 12.369 14.5771 14.1107 15.2635L14.3042 15.3404L14.3605 15.1399C14.4772 14.724 14.7105 14.3505 15.0344 14.0581C15.0577 14.0361 15.0893 14.0252 15.1209 14.0252C15.1277 14.0252 15.1346 14.0252 15.1428 14.0265L18.4821 14.5565C18.5219 14.5633 18.5548 14.5853 18.5754 14.6196C18.7127 14.8571 18.8046 15.1166 18.8513 15.3884C18.8732 15.5092 18.8828 15.6369 18.8828 15.7701C18.8828 17.04 17.8494 18.0738 16.5784 18.0752Z"
                fill="#FDFDFD"
              />
              <path
                d="M25.4705 11.2439C25.2002 8.1879 23.8002 5.35289 21.5288 3.26198C19.2436 1.15872 16.279 0 13.1786 0C6.37381 0 0.837228 5.53823 0.837228 12.345C0.837228 14.6295 1.46718 16.8549 2.65987 18.7935L0 24.6831L8.51626 23.7757C9.99717 24.3825 11.5645 24.69 13.1772 24.69C13.6013 24.69 14.0364 24.668 14.4728 24.6227C14.8571 24.5815 15.2456 24.5211 15.6271 24.4443C21.3256 23.2924 25.4856 18.2333 25.5186 12.4109V12.345C25.5186 11.9743 25.5021 11.6036 25.4692 11.2439H25.4705ZM8.84429 21.1905L4.13256 21.693L5.53935 18.5752L5.25799 18.1976C5.2374 18.1702 5.21682 18.1427 5.19349 18.1111C3.97198 16.4238 3.3269 14.4304 3.3269 12.3464C3.3269 6.91249 7.74629 2.49179 13.1786 2.49179C18.2677 2.49179 22.5815 6.46355 22.9973 11.5336C23.0193 11.8055 23.0316 12.0787 23.0316 12.3477C23.0316 12.4246 23.0303 12.5001 23.0289 12.5811C22.9246 17.1268 19.75 20.9873 15.3087 21.9703C14.9697 22.0458 14.6224 22.1035 14.2766 22.1406C13.917 22.1817 13.5478 22.2023 13.1813 22.2023C11.8761 22.2023 10.6079 21.9497 9.40975 21.45C9.27662 21.3964 9.14622 21.3388 9.02407 21.2797L8.84566 21.1933L8.84429 21.1905Z"
                fill="#FDFDFD"
              />
            </svg>
            {currentLang.whatsapp}
          </a>

          <a
            href={`mailto:${job.email}`}
            className="w-[194px] h-[66px] border border-[f1f1f2] bg-[#fff] text-[#075178] rounded-[20px] font-['Cairo'] text-sm hover:bg-[#ffeaea] flex items-center justify-center gap-[5px]"
          >
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.32812 7.58355L11.0448 12.621C12.2004 13.4877 13.7892 13.4877 14.9448 12.621L21.6615 7.5835"
                stroke="#075178"
                stroke-width="2.16667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M20.5833 5.4165H5.41667C4.22005 5.4165 3.25 6.38655 3.25 7.58317V18.4165C3.25 19.6131 4.22005 20.5832 5.41667 20.5832H20.5833C21.78 20.5832 22.75 19.6131 22.75 18.4165V7.58317C22.75 6.38655 21.78 5.4165 20.5833 5.4165Z"
                stroke="#075178"
                stroke-width="2.16667"
                stroke-linecap="round"
              />
            </svg>
            {currentLang.email}
          </a>

          <button
            onClick={() => setShowCommunication(false)}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18"
                stroke="#fff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="#fff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default JobCard;
